export interface SampleQuestion {
  question: string;
  choices: string[];
  correct: number;
  explanation: string;
}

// 100問プール — 毎回5問をランダムで出題
export const questionPool: SampleQuestion[] = [
  // === プロンプト設計 (20問) ===
  {
    question: "企画部門がAIを使って新規事業のアイデアを発散させたい。出力の多様性を高めるために調整すべきパラメータとして正しいものはどれか。",
    choices: ["温度（Temperature）を高めに設定し、出力のランダム性を上げる。", "最大トークン数を増やして、生成される文章量を多くする。", "システムプロンプトに「必ず正確に」と記載し、精度を優先させる。", "シード値を固定して、毎回同じ出力が得られるようにする。"],
    correct: 0,
    explanation: "温度を上げると出力の多様性が増し、アイデア発散に適します。シード値の固定は再現性のための設定です。",
  },
  {
    question: "総務部がAIに社内規程の要約を依頼する際、毎回フォーマットが異なり手戻りが発生している。出力の一貫性を高めるための対策として最も適切なものはどれか。",
    choices: ["「箇条書きで、各項目は30字以内、項目数は5つ」のように出力形式を具体的に指定する。", "同じ質問を5回繰り返して、最も良い出力を手動で選ぶ。", "AIのバージョンを最新に更新し、自動的にフォーマットが統一されるのを待つ。", "要約対象の文書を短く切り詰めてから入力し、AIの処理負荷を減らす。"],
    correct: 0,
    explanation: "出力形式（箇条書き・文字数・項目数）を明示的に指定することで、毎回の出力の一貫性が高まります。",
  },
  {
    question: "営業チームがAIで顧客向け提案書のドラフトを作成している。ある担当者だけが上手く使えており、他のメンバーは品質がばらつく。チーム全体の品質を安定させるために最も効果的な施策はどれか。",
    choices: ["上手く使えている担当者のプロンプトをテンプレート化し、チームで共有する。", "AI活用は得意な担当者に一任し、他のメンバーは従来の手法で作成する。", "全員に高性能なPCを支給し、AIの処理速度を改善する。", "AIの利用回数に上限を設け、使いすぎによる品質低下を防ぐ。"],
    correct: 0,
    explanation: "属人化を防ぐには、成功パターンをテンプレート化してチームで再現可能な形にすることが有効です。",
  },
  {
    question: "マーケティング部がAIにキャッチコピー案を10個出すよう依頼したが、似たような表現ばかりが返ってきた。より幅広いアイデアを得るための指示として最も適切なものはどれか。",
    choices: ["「以下の切り口でそれぞれ2案ずつ作成：感情訴求、数字訴求、問いかけ型、比較型、ストーリー型」と視点を分けて指定する。", "「もっと良いものを出して」と追加で指示し、AIの努力を促す。", "別のAIサービスに同じ依頼をして結果を比較する。", "出力された10個の中から無作為に5つ選び、残りを捨てる。"],
    correct: 0,
    explanation: "切り口や視点を明示的に分けて指定することで、AIは多様な方向性のアイデアを生成しやすくなります。",
  },
  {
    question: "法務部がAIに契約書のリスク条項を抽出させたい。AIへの指示として最も適切なものはどれか。",
    choices: ["抽出したい項目（損害賠償、解除条件、競業避止等）を具体的にリストアップして指示する。", "「この契約書で問題になりそうな箇所を教えて」とだけ依頼する。", "契約書全文を入力し「要約して」と指示する。", "AIに「あなたは弁護士です」とだけ伝えてから契約書を渡す。"],
    correct: 0,
    explanation: "抽出したい項目を具体的に列挙することで、AIは的確な条項を見逃さず抽出できます。",
  },
  {
    question: "広報部がAIにプレスリリースを作成させたところ、文体がカジュアルすぎた。適切な対処として最も正しいものはどれか。",
    choices: ["「ですます調で、公式文書に適したフォーマルな文体で作成してください」と出力の文体を明示する。", "出力された文をすべて手動で書き直す。", "AIの温度パラメータを0に設定する。", "別のAIモデルに切り替える。"],
    correct: 0,
    explanation: "文体の指定を明示的に含めることで、望む品質の出力を安定して得られます。",
  },
  {
    question: "研修担当者がAIにFAQ集を作成させたが、回答が長すぎて使いづらかった。改善策として最も適切なものはどれか。",
    choices: ["「各回答は3行以内、専門用語を避けて平易な表現で」と文量と文体の制約を加える。", "出力されたFAQから手動で不要な文を削除する。", "質問数を減らして1問ずつ生成させる。", "回答を短くするためにAIの最大トークン数を10に設定する。"],
    correct: 0,
    explanation: "文量と表現レベルの制約を事前に指定することで、用途に合った出力を直接得られます。",
  },
  {
    question: "情報システム部がAIにシステム障害の報告書テンプレートを作成させたい。再利用性の高い指示として最も適切なものはどれか。",
    choices: ["「発生日時、影響範囲、原因分析、暫定対応、恒久対策、再発防止策の6項目で構成し、各項目は箇条書き3〜5点で記載」と構造を定義する。", "「障害報告書を作って」とだけ指示する。", "過去の報告書をそのまま貼り付けて「これと同じものを作って」と依頼する。", "AIに「あなたはITエンジニアです」と役割だけ伝える。"],
    correct: 0,
    explanation: "出力の構造（項目名・形式・分量）を具体的に定義することで、再利用しやすいテンプレートが得られます。",
  },
  {
    question: "カスタマーサポート部門がAIに問い合わせ対応メールの下書きを作成させている。同じ質問に対して毎回異なる文面が出力される問題を解決するための対策として最も適切なものはどれか。",
    choices: ["定型の挨拶文・締め文とメール構成をシステムプロンプトに定義し、回答部分のみAIに生成させる。", "メールの下書きを5回生成し、最も良いものを毎回選ぶ。", "AIの利用をやめて、すべて手動で対応する。", "出力された文面を上司が毎回チェックして修正する。"],
    correct: 0,
    explanation: "定型部分をシステムプロンプトで固定し、変動部分のみAIに生成させることで品質が安定します。",
  },
  {
    question: "経営企画部がAIに競合分析レポートを作成させたところ、情報の出典が不明確だった。出力の信頼性を高めるための指示として最も適切なものはどれか。",
    choices: ["「各主張には情報源を明記し、出典が不明な場合は『未確認情報』と注記してください」と指示する。", "AIに「正確な情報だけを出力して」と強く依頼する。", "出力されたレポートをそのまま社内に配布する。", "競合分析には使わず、社内データの分析のみにAIを活用する。"],
    correct: 0,
    explanation: "出典の明記と不確実性の注記を指示に含めることで、出力の信頼性と透明性が向上します。",
  },
  // === データの取り扱い・セキュリティ (20問) ===
  {
    question: "人事部がAIを使って採用面接の質問リストを作成したところ、特定の属性に偏った質問が含まれていた。AIの出力を業務で使う際に最も重要な姿勢はどれか。",
    choices: ["AIの出力は必ず人間が確認し、不適切な内容がないかレビューしてから使用する。", "AIが生成した内容はすべて中立であるため、そのまま採用して問題ない。", "偏りのある出力が出た場合はAIの利用を即座に停止し、手作業に切り替える。", "出力に問題があった場合、AIサービスの提供元に修正を依頼して対応を待つ。"],
    correct: 0,
    explanation: "AIの出力にはバイアスが含まれる可能性があります。業務利用では必ず人間がレビューし、修正した上で使うことが基本です。",
  },
  {
    question: "経理部がAIに請求書データの整理を依頼する際、取引先名や金額を含むデータをそのまま外部AIサービスに送信しようとしている。この行為に対する指摘として最も適切なものはどれか。",
    choices: ["機密性の高いデータは匿名化またはマスク処理してから送信すべきである。", "請求書データは公開情報なので、特別な対処なく送信して問題ない。", "暗号化されたネットワークを使用していれば、どのようなデータも安全に送信できる。", "社内で承認を得ていれば、個人情報や機密データの外部送信は許可される。"],
    correct: 0,
    explanation: "取引先情報や金額は機密情報にあたります。外部AIサービスに送信する前に匿名化・マスク処理を行うのが原則です。",
  },
  {
    question: "営業部が顧客リストをAIに読み込ませて分析レポートを作成しようとしている。情報管理の観点から最も注意すべき点はどれか。",
    choices: ["顧客の個人情報（氏名・連絡先等）をマスクまたは除去してからAIに入力する。", "顧客リストは業務資料なので、AIへの入力に特別な制限はない。", "AIがデータを記憶しないように「このデータは忘れて」と指示する。", "レポート完成後にAIとの会話履歴を削除すれば問題ない。"],
    correct: 0,
    explanation: "顧客の個人情報は外部サービスに送信する前にマスク処理が必要です。AIへの「忘れて」の指示では確実なデータ保護にはなりません。",
  },
  {
    question: "医療機関の事務員がAIに診療報酬の計算方法を質問する際、患者の実名と病名を含めて質問文を作成した。この行為の問題点として最も適切なものはどれか。",
    choices: ["患者の実名や病名は要配慮個人情報であり、外部AIへの送信は個人情報保護の観点で不適切である。", "AIは医療情報を正確に処理できないため、計算結果が間違う可能性がある。", "診療報酬の計算は法律で人間のみが行うと定められている。", "医療機関のネットワークからAIにアクセスすること自体が禁止されている。"],
    correct: 0,
    explanation: "患者の実名や病名は要配慮個人情報です。質問する際は個人を特定できない形に加工してからAIに入力すべきです。",
  },
  {
    question: "社内でAI利用ガイドラインを策定する際、最も優先して定めるべき項目はどれか。",
    choices: ["AIに入力してはいけない情報の種類と、入力前に必要な加工ルール。", "AIが利用できる時間帯と利用回数の上限。", "AI利用に関する研修の受講義務。", "AIの出力を社外に公開する際のフォーマット。"],
    correct: 0,
    explanation: "最も優先すべきはデータ保護です。何を入力してよいか・いけないかの基準を明確にすることがリスク管理の第一歩です。",
  },
  {
    question: "開発チームがAIコーディング支援ツールを導入した。社内の非公開コードをAIに読み込ませる際、最も注意すべき点はどれか。",
    choices: ["AIサービスの利用規約を確認し、入力データが学習に使われないことを確認する。", "コードを圧縮してから入力すれば情報漏洩のリスクは低い。", "社内ネットワーク内で使用する限り、外部へのデータ流出は起こらない。", "開発中のコードは未公開なので機密情報には該当しない。"],
    correct: 0,
    explanation: "AIサービスによっては入力データが学習に利用される場合があります。利用規約の確認は必須です。",
  },
  {
    question: "管理職がAIを使って部下の人事評価コメントを作成しようとしている。この利用に関する注意点として最も適切なものはどれか。",
    choices: ["部下の氏名や個人的な事情をAIに入力せず、職務上の実績のみを匿名化して入力する。", "人事評価は公正に行う必要があるため、AIの出力をそのまま使えば主観が排除できる。", "評価コメントは社内文書なので、AIへの入力に特段の制限はない。", "AIが生成した評価は客観的であるため、上長のレビューは不要である。"],
    correct: 0,
    explanation: "人事評価に関する情報は個人の権利に直結します。個人を特定できない形で入力し、出力は必ず人間がレビューする必要があります。",
  },
  {
    question: "自治体職員がAIを使って住民向けの案内文を作成する際、住民の世帯情報を含む相談内容をそのままAIに入力した。この行為の問題点はどれか。",
    choices: ["住民の世帯情報は個人情報であり、外部クラウドサービスへの送信は情報漏洩リスクがある。", "AIは自治体の文書スタイルに対応していないため、出力品質が低い。", "住民情報は公開情報なので問題はないが、AI利用の記録を残す必要がある。", "自治体職員は業務中のAI利用が法律で禁止されている。"],
    correct: 0,
    explanation: "住民の世帯情報は個人情報です。外部AIサービスに送信する前に、個人を特定できない形に加工する必要があります。",
  },
  {
    question: "製造業の品質管理部門がAIに不良品の分析を依頼する際、社内の製造ノウハウが含まれるデータも一緒に入力しようとしている。最も適切な対応はどれか。",
    choices: ["製造ノウハウは営業秘密に該当する可能性があるため、分析に不要な技術詳細は除外してから入力する。", "品質管理のためなのでノウハウの流出は許容される。", "AIの出力を社外に公開しなければ問題ない。", "社内サーバーで動作するAIなら、どんなデータでも安全に入力できる。"],
    correct: 0,
    explanation: "製造ノウハウは営業秘密に該当し得ます。分析目的に必要な情報のみに絞って入力するのが適切です。",
  },
  {
    question: "採用担当者がAIに応募者の履歴書を読み込ませてスクリーニングを行いたいと考えている。この利用に伴う最大のリスクはどれか。",
    choices: ["AIが学歴・年齢・性別等に基づく偏った評価を行い、差別的な選考結果を生む可能性がある。", "AIが履歴書の内容を正確に読み取れず、誤字を見逃す可能性がある。", "処理速度が遅く、大量の履歴書を時間内に処理できない可能性がある。", "応募者がAIによるスクリーニングに不満を持ち、辞退する可能性がある。"],
    correct: 0,
    explanation: "AIによる採用スクリーニングでは、学歴や年齢等に基づくバイアスによる差別的判断のリスクが最も重大です。",
  },
  // === 出力品質の管理 (20問) ===
  {
    question: "広報部がAIに製品紹介記事を作成させたところ、実際には存在しない機能が記載されていた。この現象の名称と対策として正しいものはどれか。",
    choices: ["ハルシネーション（幻覚）と呼ばれ、出力内容を事実と照合するファクトチェックが必要。", "バグと呼ばれ、AIサービスの提供元に不具合報告が必要。", "オーバーフィッティングと呼ばれ、AIの学習データを追加すれば解決する。", "キャッシュエラーと呼ばれ、ブラウザを再起動すれば解消する。"],
    correct: 0,
    explanation: "AIが事実と異なる情報を自信を持って出力する現象をハルシネーションと呼びます。必ずファクトチェックが必要です。",
  },
  {
    question: "教育機関がAIに試験問題を作成させたところ、同じような問い方のパターンが繰り返されていた。出力の多様性を改善するための対策として最も適切なものはどれか。",
    choices: ["「正誤判断型、穴埋め型、事例判断型、比較選択型を各5問ずつ」と出題形式を明示的に指定する。", "温度パラメータを最大にして、ランダム性を極限まで高める。", "問題数を倍にして、その中から手動で良い問題を選ぶ。", "複数のAIサービスで同時に生成して結果を統合する。"],
    correct: 0,
    explanation: "出題形式の種類を具体的に指定することで、AIは意図的に多様なパターンの問題を生成できます。",
  },
  {
    question: "翻訳チームがAIに英日翻訳を依頼したところ、専門用語の訳語が統一されていなかった。品質改善のために最も効果的な対策はどれか。",
    choices: ["用語集（グロッサリー）を事前に提示し、「以下の用語対応表に従って翻訳すること」と指示する。", "翻訳後に手動で用語を統一する。", "AIに「専門用語を正確に翻訳して」と強調する。", "機械翻訳の精度が低いため、AIの利用を中止する。"],
    correct: 0,
    explanation: "用語集を事前に提示することで、専門用語の訳語が統一され、翻訳品質が大幅に向上します。",
  },
  {
    question: "コンサルタントがAIに市場分析レポートを作成させたところ、古いデータに基づいた記述が含まれていた。この問題への最も適切な対処はどれか。",
    choices: ["AIのトレーニングデータには時間的な制約があるため、最新の統計データは人間が確認・補完する運用にする。", "AIに「2024年以降のデータのみ使用して」と指示すれば正確なデータが得られる。", "レポート作成にはAIを使わず、すべて手動で調査する。", "AIの出力をそのまま使い、日付に「※AIによる推定」と注記する。"],
    correct: 0,
    explanation: "AIの学習データには時間的な限界があります。最新データは人間が確認・補完する運用が必要です。",
  },
  {
    question: "AIが生成したビジネスメールの品質を継続的に改善するために最も効果的なアプローチはどれか。",
    choices: ["良い出力例と悪い出力例を蓄積し、Few-shotの参考例としてプロンプトに含める。", "毎回同じプロンプトを使い続け、AIの学習効果を期待する。", "品質が悪い出力が出た場合はAIを使わず手動で書き直す。", "複数のAIサービスの出力を比較して、最も良いものを選ぶ。"],
    correct: 0,
    explanation: "良い例・悪い例をFew-shotとしてプロンプトに含めることで、出力品質を体系的に改善できます。",
  },
  {
    question: "AIに議事録の要約を依頼したところ、重要な決定事項が省略されていた。再発防止として最も適切な対策はどれか。",
    choices: ["「決定事項、担当者、期限を必ず含めること」と出力に必要な項目を明示する。", "要約ではなく全文を出力させるように変更する。", "議事録の長さを半分にしてからAIに入力する。", "AIの出力精度が低いため、議事録の要約にAIを使うのをやめる。"],
    correct: 0,
    explanation: "出力に含めるべき必須項目を明示することで、重要な情報の欠落を防げます。",
  },
  {
    question: "AIに社内報の記事を作成させたところ、表現が堅すぎて社風に合わなかった。改善するための最も効果的な方法はどれか。",
    choices: ["過去の社内報記事を2〜3本参考例として添付し、「このトーンに合わせて」と指示する。", "AIに「もっとカジュアルに」と繰り返し指示する。", "社内報の記事作成にAIを使うのをやめる。", "出力された記事を手動で全文書き直す。"],
    correct: 0,
    explanation: "具体的な参考例を提示するFew-shot手法が、文体やトーンの調整に最も効果的です。",
  },
  {
    question: "AIの出力品質を定量的に評価するための指標として最も適切なものはどれか。",
    choices: ["正確性（事実との一致度）、一貫性（フォーマットの統一度）、完全性（必須項目の網羅度）の3軸で評価する。", "出力の文字数が多いほど品質が高いと評価する。", "AIの応答速度が速いほど品質が高いと評価する。", "人間が読んで「なんとなく良い」と感じたものを合格とする。"],
    correct: 0,
    explanation: "正確性・一貫性・完全性の3軸で定量的に評価することで、客観的な品質管理が可能になります。",
  },
  {
    question: "AIにプレゼン資料のスライド構成案を作成させたところ、すべてのスライドが同じ構造で単調だった。改善するための指示として最も適切なものはどれか。",
    choices: ["「導入→課題提示→データ→解決策→事例→まとめ」のようにスライドごとの役割を指定する。", "スライド数を増やして情報量を多くする。", "AIにデザインテンプレートを適用させる。", "文字の色やフォントサイズの変更を指示する。"],
    correct: 0,
    explanation: "各スライドの役割や展開構造を指定することで、論理的で変化のある構成案を得られます。",
  },
  {
    question: "AIに技術文書の校正を依頼したところ、正しい専門用語が一般的な表現に置き換えられていた。この問題を防ぐための対策として最も適切なものはどれか。",
    choices: ["「専門用語はそのまま残し、文法・表記の統一のみを修正対象とすること」と校正範囲を限定する。", "校正にAIを使うのをやめる。", "AIに専門分野の資格証を提示する。", "温度パラメータを下げて保守的な出力にする。"],
    correct: 0,
    explanation: "校正の範囲を明示的に限定することで、専門用語の不適切な書き換えを防げます。",
  },
  // === 運用・ガバナンス (15問) ===
  {
    question: "企業がAI活用を推進する際、全社的なAI利用ポリシーに最も優先して含めるべき項目はどれか。",
    choices: ["利用禁止データの定義と、違反時の報告・対応フロー。", "推奨するAIサービスの一覧と料金比較表。", "AI活用によるコスト削減目標と達成期限。", "AI利用に関する社内コンテストの開催計画。"],
    correct: 0,
    explanation: "AI利用ポリシーの最優先事項は、禁止事項と違反時の対応フローを明確にすることです。",
  },
  {
    question: "部門間でAIの活用ノウハウを共有する方法として最も効果的なものはどれか。",
    choices: ["成功したプロンプトと失敗したプロンプトの両方を事例集にまとめ、社内ナレッジベースで公開する。", "各部門のAI利用時間を集計して社内ランキングを作成する。", "AI利用者同士の懇親会を月に1回開催する。", "各部門にAI利用担当者を1名ずつ任命し、その人だけが使う体制にする。"],
    correct: 0,
    explanation: "成功例と失敗例の両方を体系化して共有することで、組織全体のAI活用レベルが底上げされます。",
  },
  {
    question: "AIの出力をそのまま社外に公開する際に最も注意すべき点はどれか。",
    choices: ["事実確認を行い、著作権侵害や不正確な情報がないか確認してから公開する。", "AIが生成したことを明記すれば、内容の正確性は免責される。", "社内レビューを通せば、ファクトチェックは不要である。", "AIの出力には著作権が発生しないため、自由に公開できる。"],
    correct: 0,
    explanation: "社外公開前には事実確認と著作権チェックが必須です。AI生成物であることは免責事由にはなりません。",
  },
  {
    question: "AIの導入効果を経営層に報告する際、最も説得力のある指標はどれか。",
    choices: ["AI導入前後で比較可能な業務時間の短縮率やエラー率の変化。", "AI利用者数の推移。", "AIサービスの利用料金の推移。", "社員のAI利用に対する満足度アンケート結果。"],
    correct: 0,
    explanation: "導入前後で比較可能な定量指標（時間短縮率・エラー率）が最も客観的で説得力があります。",
  },
  {
    question: "AIが生成した文章を社外プレゼンで使用する際、最も適切な対応はどれか。",
    choices: ["内容の正確性を確認し、必要に応じて修正した上で、発表者が責任を持って使用する。", "AIが作成したことを冒頭で説明し、内容の正確性はAIに委ねる。", "AIの出力をそのまま使えば客観的な内容になるため、確認は不要。", "AIの出力を使用したことを隠し、自分で作成したことにする。"],
    correct: 0,
    explanation: "AI生成物を使用する場合でも、内容の責任は利用者にあります。事実確認と修正を行い、責任を持って使用します。",
  },
  {
    question: "AIツールのアクセス権限を社内で設定する際、最も重要な原則はどれか。",
    choices: ["業務に必要な範囲のみアクセス可能とする最小権限の原則を適用する。", "全社員に同じ権限を付与して公平性を確保する。", "管理職には制限なしのアクセス権を付与する。", "IT部門のみがアクセス権を持ち、利用申請制にする。"],
    correct: 0,
    explanation: "最小権限の原則により、各従業員が業務に必要な範囲のみAIにアクセスできるよう制限することが重要です。",
  },
  {
    question: "AIの利用に関して社員から「どこまでAIに任せてよいかわからない」という相談があった。最も適切な回答はどれか。",
    choices: ["AIは下書きやアイデア出しに使い、最終判断と確認は必ず人間が行うのが基本ルール。", "AIが正しいと判断したものはそのまま使ってよい。", "責任者の承認があれば、AIの出力をそのまま使ってよい。", "AIに任せる範囲は個人の裁量に委ねる。"],
    correct: 0,
    explanation: "AIの役割は補助であり、最終判断と品質確認は人間が行うという原則を明確にすることが重要です。",
  },
  {
    question: "AI利用に関するインシデント（情報漏洩等）が発生した場合、最初に行うべき対応はどれか。",
    choices: ["該当するAIサービスの利用を一時停止し、事実関係の調査と影響範囲の特定を行う。", "AI利用者全員にメールで注意喚起を行う。", "AIサービスの提供元に損害賠償を請求する。", "社内のAI利用を全面禁止にする。"],
    correct: 0,
    explanation: "インシデント発生時は、まず利用停止と事実調査・影響範囲の特定が最優先です。",
  },
  {
    question: "新入社員へのAI利用研修で最も重要なテーマはどれか。",
    choices: ["AIに入力してはいけない情報の具体例と、出力を確認する際のチェックポイント。", "様々なAIサービスの機能比較と料金プラン。", "AIの技術的な仕組み（ニューラルネットワーク等）の詳細解説。", "AIを使った業務効率化の成功事例の紹介。"],
    correct: 0,
    explanation: "新入社員にはまず「何を入力してはいけないか」「出力をどう確認するか」の実践的な基準を教えることが最重要です。",
  },
  {
    question: "AIの出力結果に基づいて重要な経営判断を行う場合、最も適切なプロセスはどれか。",
    choices: ["AIの出力を参考情報として扱い、複数の情報源と照合した上で人間が最終判断を下す。", "AIの分析結果を唯一の判断根拠として採用する。", "AIの出力と反対の判断を行うことで、バイアスを排除する。", "AIの確信度が80%以上であれば、そのまま判断に採用する。"],
    correct: 0,
    explanation: "AIの出力は参考情報の一つであり、複数の情報源と照合して人間が最終判断を行うべきです。",
  },
  // === AI基礎概念 (15問) ===
  {
    question: "AIの「トークン」に関する説明として正しいものはどれか。",
    choices: ["AIが文章を処理する際の最小単位で、単語や文字の一部が1トークンに対応する。", "AIサービスの利用権限を管理するための認証キーのこと。", "AIモデルの学習に使用するデータセットの単位のこと。", "AIが1回の応答で生成できるファイルの最大サイズのこと。"],
    correct: 0,
    explanation: "トークンはAIがテキストを処理する際の最小単位です。日本語では1文字が1〜3トークンに対応します。",
  },
  {
    question: "AIの「コンテキストウィンドウ」が業務上重要な理由として正しいものはどれか。",
    choices: ["一度に処理できる入力と出力の合計量に上限があり、長い文書を扱う際に制約となるため。", "AIが表示するウィンドウのサイズを設定するもので、画面表示に影響するため。", "AIが同時に処理できるユーザー数の上限を決めるもので、チーム利用に影響するため。", "AIの応答時間を決定するもので、処理速度に直結するため。"],
    correct: 0,
    explanation: "コンテキストウィンドウはAIが一度に扱えるテキスト量の上限で、長い文書や長い会話では情報の切り捨てが起こります。",
  },
  {
    question: "AIの「ファインチューニング」の説明として正しいものはどれか。",
    choices: ["既存のAIモデルを特定の業務データで追加学習させ、特定のタスクに特化させる手法。", "AIの出力画面のフォントサイズや配色を調整すること。", "AIモデルのバージョンを最新に更新すること。", "AIの応答速度を最適化するためのサーバー設定のこと。"],
    correct: 0,
    explanation: "ファインチューニングは、汎用AIモデルを特定の業務やデータに合わせて追加学習させる手法です。",
  },
  {
    question: "RAG（検索拡張生成）の仕組みとして正しいものはどれか。",
    choices: ["AIが回答を生成する前に外部のデータベースから関連情報を検索し、その情報を根拠として回答を生成する。", "AIの回答速度を向上させるために、複数のAIモデルを並列で動作させる仕組み。", "AIの出力をリアルタイムでWebに公開するための配信システム。", "AIモデルのサイズを圧縮して、スマートフォンでも動作させる技術。"],
    correct: 0,
    explanation: "RAGは外部データベースから関連情報を検索してからAIに回答させる手法で、最新情報や社内文書に基づく回答を可能にします。",
  },
  {
    question: "AIの出力に「バイアス」が含まれる主な原因として正しいものはどれか。",
    choices: ["学習データに含まれる偏り（特定の性別・文化等の過少/過剰代表）が出力に反映されるため。", "AIのハードウェア（GPU等）の製造上の欠陥によるもの。", "AIの開発者が意図的に偏った回答をプログラムしているため。", "インターネット接続の品質が不安定で、データが破損するため。"],
    correct: 0,
    explanation: "AIの学習データに含まれる社会的な偏りが出力に反映されます。これは意図的なものではなく、データの特性に起因します。",
  },
  {
    question: "AIが生成した文章の著作権に関する記述として、現時点で最も適切なものはどれか。",
    choices: ["AI生成物の著作権は法的に未確定な部分が多く、人間の創作的関与の度合いによって判断が異なる。", "AIが生成した文章には自動的に著作権が発生し、AIサービスの提供元に帰属する。", "AI生成物には一切著作権が発生しないため、誰でも自由に使用できる。", "AIを使った時点で著作権は利用者に帰属し、完全に保護される。"],
    correct: 0,
    explanation: "AI生成物の著作権は各国の法制度で異なり、人間がどの程度創作的に関与したかが判断基準になります。",
  },
  {
    question: "「プロンプトインジェクション」攻撃の説明として正しいものはどれか。",
    choices: ["AIへの入力に悪意ある指示を混入させ、AIに意図しない動作をさせる攻撃手法。", "AIの学習データにウイルスを混入させる攻撃手法。", "AIサーバーに大量のリクエストを送り、サービスを停止させる攻撃手法。", "AIの出力結果を改ざんする中間者攻撃の一種。"],
    correct: 0,
    explanation: "プロンプトインジェクションは、AIへの入力に悪意ある指示を含めて、本来の動作を逸脱させる攻撃です。",
  },
  {
    question: "AIの「Few-shot学習」を業務で活用する具体的な方法として正しいものはどれか。",
    choices: ["AIへの指示に2〜3個の入出力例を含め、期待する出力の形式や内容をAIに学習させる。", "AIモデルを少量のデータでゼロから訓練すること。", "AIに1回だけ質問して、その回答の品質で利用可否を判断すること。", "少人数のチームでAIの導入テストを行うこと。"],
    correct: 0,
    explanation: "Few-shot学習はプロンプトに数個の例を含めることで、AIに期待する出力パターンを示す手法です。",
  },
  {
    question: "AIの「ガードレール」の役割として正しいものはどれか。",
    choices: ["AIの入出力を監視し、不適切なコンテンツや禁止された操作をブロックする安全装置。", "AIの処理速度を制限して、サーバーの過負荷を防ぐ仕組み。", "AIの出力を暗号化して、第三者からの盗聴を防ぐセキュリティ機能。", "AIモデルの更新頻度を制御して、急激な品質変化を防ぐ機能。"],
    correct: 0,
    explanation: "ガードレールはAIの安全装置として、禁止コンテンツの生成や不正な操作をブロックします。",
  },
  {
    question: "「マルチモーダルAI」の特徴として正しいものはどれか。",
    choices: ["テキスト、画像、音声など複数の種類のデータを組み合わせて処理できるAI。", "複数のAIモデルを同時に動作させて処理速度を上げる技術。", "複数の言語に対応した翻訳専用のAI。", "複数のユーザーが同時にアクセスできるAIサービスの形態。"],
    correct: 0,
    explanation: "マルチモーダルAIはテキスト・画像・音声など複数の情報形式を統合的に処理できるAIです。",
  },
  // === 評価と検証 (10問) ===
  {
    question: "AIの出力品質が安定しているか確認するために最も有効な手法はどれか。",
    choices: ["同じ入力で定期的にテストを実施し、出力が基準を満たしているか回帰テストを行う。", "毎月1回、AIの出力をランダムに1件チェックする。", "AIサービスの稼働率を監視する。", "ユーザーからのクレーム件数を月次で集計する。"],
    correct: 0,
    explanation: "回帰テスト（同じ入力で定期的にテスト）により、AIの出力品質が維持されているかを客観的に確認できます。",
  },
  {
    question: "AIを導入する際の評価基準として最も不適切なものはどれか。",
    choices: ["AIの出力を人間の判断なしでそのまま使える割合（完全自動化率）。", "AIの出力が正確であった割合（精度）。", "AIの導入前後での業務時間の変化。", "AIの出力に対する利用者の修正量。"],
    correct: 0,
    explanation: "「完全自動化率」を指標にすると、人間のレビューを省略する方向に誘導されるリスクがあり、評価基準として不適切です。",
  },
  {
    question: "AIを活用した業務プロセスの改善サイクルとして最も適切なものはどれか。",
    choices: ["指示の作成→AI出力の取得→品質評価→指示の改善→再実行のサイクルを繰り返す。", "一度良い結果が出たら、同じ指示を永続的に使い続ける。", "AIの出力が期待通りでない場合は、別のAIサービスに乗り換える。", "改善サイクルは四半期に1回、定例会議で検討する。"],
    correct: 0,
    explanation: "指示の改善→品質評価を繰り返すPDCAサイクルにより、AIの活用品質を継続的に向上できます。",
  },
  {
    question: "AIの出力を評価する際、「正確性」「有用性」「安全性」の3つの観点のうち、最も優先すべき観点はどれか。",
    choices: ["安全性。不正確でも有用でも、有害な出力は最も深刻な問題を引き起こすため。", "正確性。事実と異なる情報が最も信頼を損なうため。", "有用性。業務に役立たない出力は価値がないため。", "3つとも同等の優先度であり、順位をつけるべきではない。"],
    correct: 0,
    explanation: "安全性が最優先です。有害な出力（差別的表現、個人情報漏洩等）は法的リスクや社会的ダメージが大きいためです。",
  },
  {
    question: "AIの出力品質を「受入基準」で管理する方法として最も適切なものはどれか。",
    choices: ["出力に含まれるべき必須項目と、不合格となる条件（禁止表現・フォーマット違反等）を事前に定義する。", "上長が「良い」と判断したものを合格とする。", "AIの出力に含まれる文字数が一定以上であれば合格とする。", "AIの処理時間が10秒以内であれば品質が高いと判断する。"],
    correct: 0,
    explanation: "必須項目と不合格条件を事前に定義することで、客観的で再現可能な品質管理が実現します。",
  },
  {
    question: "AIの出力を複数人でレビューする「二重レビュー」が有効な場面はどれか。",
    choices: ["法的文書や公開文書など、誤りが重大な影響を及ぼす出力の確認。", "日常的なメモやToDoリストの作成。", "社内チャットでの雑談返信。", "個人の学習ノートの作成。"],
    correct: 0,
    explanation: "二重レビューは、法的文書や公開文書など誤りの影響が大きい場面で特に有効です。",
  },
  {
    question: "AIの導入効果を測定するためのベースラインとして最も適切なものはどれか。",
    choices: ["AI導入前の同一業務における処理時間、品質指標、コストを記録しておく。", "業界平均のAI活用率を参照する。", "AIサービスの公式サイトに掲載されている導入事例の数値を使う。", "社員の感覚的な評価（「速くなった気がする」等）を記録する。"],
    correct: 0,
    explanation: "AI導入前のデータを記録しておくことで、導入後と客観的に比較でき、正確な効果測定が可能になります。",
  },
  {
    question: "AIの出力に対する利用者のフィードバックを収集する方法として最も効果的なものはどれか。",
    choices: ["出力の利用時に「修正が必要だった箇所」と「修正内容」を記録するシンプルなフォームを用意する。", "月に1回、AI利用に関する感想をメールで収集する。", "AIに「自分の出力を評価して」と自己評価させる。", "SNSでAI活用の体験談を募集する。"],
    correct: 0,
    explanation: "修正箇所と修正内容を具体的に記録することで、プロンプト改善に直結するフィードバックが得られます。",
  },
  {
    question: "AIの出力に含まれる数値データの信頼性を確認する方法として最も適切なものはどれか。",
    choices: ["AIが出力した数値を公的統計や一次情報源と照合して事実確認を行う。", "数値が具体的であれば信頼性が高いと判断する。", "AIに「この数値は正確ですか？」と確認する。", "別のAIに同じ質問をして、数値が一致すれば正しいと判断する。"],
    correct: 0,
    explanation: "AIが出力する数値はハルシネーションの可能性があるため、必ず公的統計や一次情報源で確認が必要です。",
  },
  {
    question: "AIの出力品質が突然低下した場合に最初に確認すべき点はどれか。",
    choices: ["使用しているAIサービスのモデルバージョンやシステムアップデートの有無を確認する。", "AIサーバーの物理的な故障を疑い、提供元に修理を依頼する。", "社内ネットワークの速度を測定する。", "AIの利用回数が上限に達していないか確認する。"],
    correct: 0,
    explanation: "AIサービスのモデル更新やバージョン変更が品質変化の主な原因です。まずシステムの変更有無を確認します。",
  },
];

export function getRandomQuestions(count: number = 5): SampleQuestion[] {
  // Fisher-Yates with Math.random (毎回異なる順序)
  const pool = [...questionPool];
  for (let i = pool.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [pool[i], pool[j]] = [pool[j], pool[i]];
  }
  // 各問題の選択肢もシャッフル
  return pool.slice(0, count).map((q) => {
    const indices = [0, 1, 2, 3];
    for (let i = indices.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [indices[i], indices[j]] = [indices[j], indices[i]];
    }
    return {
      ...q,
      choices: indices.map((i) => q.choices[i]),
      correct: indices.indexOf(q.correct),
    };
  });
}
